import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import PortfolioData from "./portfolio.json";
import ProjectCard from "./ProjectCard";
import { LanguageContext } from "../../context/LanguageContext";

const sectionLabels = {
  en: {
    title: "Selected work",
    subtitle: "Production AI first. A shipped product at the end.",
  },
  pt: {
    title: "Trabalho selecionado",
    subtitle: "IA em produção primeiro. Um produto próprio no fim.",
  },
};

const Portfolio = () => {
  const { language } = useContext(LanguageContext);
  const t = sectionLabels[language] || sectionLabels.en;
  const projects = PortfolioData[language] || PortfolioData.en;

  return (
    <Box component="section" aria-labelledby="work-heading" className="page-width" sx={{ pb: { xs: 8, md: 10 } }}>
      <Box sx={{ textAlign: "center", pt: { xs: 8, md: 10 }, pb: { xs: 5, md: 6 } }}>
        <Typography
          id="work-heading"
          variant="h2"
          component="h2"
          sx={{ mb: 1.2, textTransform: "none", letterSpacing: -0.6, textAlign: "center" }}
        >
          {t.title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t.subtitle}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(3, 1fr)",
          },
          gap: { xs: 2.5, md: 3 },
        }}
      >
        {projects.map((project, index) => (
          <ProjectCard key={project.id} project={project} index={index} />
        ))}
      </Box>
    </Box>
  );
};

export default Portfolio;
